"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiMinusGlyph = {
    paths: [
        {
            path: 'M1,2.50200475 L15,2.50200475 C15.5522847,2.50200475 16,2.0542895 16,1.50200475 C16,0.949720005 15.5522847,0.502004755 15,0.502004755 L1,0.502004755 C0.44771525,0.502004755 0,0.949720005 0,1.50200475 C0,2.0542895 0.44771525,2.50200475 1,2.50200475 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Minus',
    width: 16,
    height: 3,
};
var muiMinus = {
    base: muiMinusGlyph,
};
exports.muiMinus = muiMinus;
//# sourceMappingURL=minus.js.map